/**
 * @since 2026-04-18
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import React, { useMemo } from "react";
import { Box } from "@mui/material";
import EChart from "components/Shared/EChart";
import ChartCard from "components/Shared/ChartCard";

const GapCalendarPanel = ({ detail }) => {
  const byYear = useMemo(() => {
    const map = new Map();
    for (const entry of detail?.calendar || []) {
      const year = entry.date?.slice(0, 4);
      if (!year) continue;
      if (!map.has(year)) map.set(year, []);
      map.get(year).push([entry.date, entry.present]);
    }
    return Array.from(map.entries()).sort(([a], [b]) => a.localeCompare(b));
  }, [detail]);

  if (!detail) return null;
  const calendar = detail.calendar || [];
  if (calendar.length === 0) {
    return <Box sx={{ opacity: 0.7 }}>No calendar data.</Box>;
  }

  const option = {
    animation: false,
    tooltip: {
      formatter: (p) => `${p.value[0]}: ${p.value[1] === 1 ? "present" : "MISSING"}`,
    },
    visualMap: {
      show: false,
      min: 0,
      max: 1,
      inRange: { color: ["#b14336", "#2f6b33"] },
    },
    calendar: byYear.map(([year], i) => ({
      top: 40 + i * 130,
      left: 60,
      right: 20,
      range: year,
      cellSize: ["auto", 14],
      dayLabel: { color: "#888" },
      monthLabel: { color: "#bbb" },
      yearLabel: { show: true, color: "#bbb" },
      itemStyle: { borderColor: "#0d1117", borderWidth: 1 },
      splitLine: { show: false },
    })),
    series: byYear.map(([, data], i) => ({
      type: "heatmap",
      coordinateSystem: "calendar",
      calendarIndex: i,
      data,
    })),
  };

  const heightPerYear = 130;
  const totalHeight = 60 + byYear.length * heightPerYear;

  return (
    <ChartCard title="Bar coverage by date">
      <EChart option={option} height={totalHeight} />
    </ChartCard>
  );
};

export default GapCalendarPanel;
